import debounce from 'lodash.debounce';
import BaseFilter from '../modules/filters/baseFilter';
import PopupVideo from '../modules/popupVideo';
import mobileCarousel from '../utils/mobileCarousel';
import simpleLightbox from 'simplelightbox';

$ = jQuery;

class MediaSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.filter = this.root.querySelector('[data-filter-switcher]');
        this.wrapper = this.root.querySelector('[data-media-section-wrapper]');
        this.more = this.root.querySelector('[data-media-section-more]');
        this.moreButton = this.root.querySelector(
            '[data-media-section-button]'
        );

        this.loaderTop = this.root.querySelectorAll(
            '[data-media-section-loader-top]'
        );
        this.loaderButton = this.root.querySelector(
            '[data-media-section-loader-button]'
        );

        this.settings = JSON.parse(
            this.root.getAttribute('data-media-section-settings')
        );
        this.wrapperHTML = this.wrapper ? this.wrapper.innerHTML : null;

        this.maxPages = this.settings.max_num_pages;
        this.listType = this.settings.list_type;
        this.perRow = this.settings.per_row;
        this.perPage = this.settings.per_page;

        this.galleryInstance = null;
        this.galleries = null;
        this.galleryItemDetails = null;
        this.currentGalleryIndex = 0;
        this.baseFilter = null;
        this.cards = [];

        this.currentPage = 1;
        this.currentCategory = null;
        this.maxNumPages = 1;

        this.loadMedia = debounce(this.getMedia, 1000);
        return true;
    }

    init() {
        this.initFilter();
        this.initMore();
        this.checkMore();
        this.setMediaCards();
    }

    initFilter() {
        if (!this.filter || !this.wrapper) return;
        this.baseFilter = new BaseFilter(this.filter, this.root);

        this.filterSwitch = this.onFilterSwitch.bind(this);
        this.root.addEventListener('filter-switcher-change', event =>
            this.filterSwitch(event)
        );

        this.baseFilter.toggleClick(0);
    }

    initMore() {
        if (!this.moreButton) return;

        this.onMore = this.onMoreClick.bind(this);
        this.moreButton.addEventListener('click', event => this.onMore(event));
    }

    getMedia() {
        if (!this.wrapper) return;

        const formData = new FormData();
        formData.append('action', 'media_list');
        formData.append('per_page', this.perPage);
        formData.append('per_row', this.perRow);
        formData.append('current_page', this.currentPage);
        formData.append('list_type', this.listType);

        if (this.currentCategory) {
            formData.append('category', this.currentCategory);
        } else {
            formData.append('category', this.settings.base_term);
        }

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { maxNumPages, html } = data;

                this.maxPages = maxNumPages;

                this.wrapperHTML += html;
                this.wrapper.innerHTML = this.wrapperHTML;

                this.checkMore();
                this.setMediaCards();
            }.bind(this),
            error: function () {
                if (this.loaderTop) this.loaderTop.forEach(loader => loader.classList.add('d-none'));
                this.loaderButton.classList.add('d-none');
            }.bind(this),
            complete: function () {
                if (this.loaderTop) this.loaderTop.forEach(loader => loader.classList.add('d-none'));
                this.loaderButton.classList.add('d-none');
            }.bind(this),
        });
    }

    mediaLoader() {
        if (this.loaderTop) this.loaderTop.forEach(loader => loader.classList.remove('d-none'));
        this.loadMedia();
    }

    onMoreClick(event) {
        if (this.currentPage >= this.maxPages) return;

        this.currentPage = this.currentPage + 1;
        this.loaderButton.classList.remove('d-none');
        this.loadMedia();
    }

    onFilterSwitch(event) {
        const { detail } = event;
        const { value } = detail;

        this.currentPage = 1;
        this.wrapperHTML = '';
        this.currentCategory = parseInt(value);
        this.mediaLoader();
    }

    checkMore() {
        if (this.more) {
            if (this.maxPages === this.currentPage || this.maxPages === 0) {
                this.more.classList.add('d-none');
            } else {
                this.more.classList.remove('d-none');
            }
        }
    }

    setMediaCards() {
        this.cards = this.root.querySelectorAll('[data-card-media]');
        if (!this.cards) return;

        this.onCard = this.onMediaCard.bind(this);
        this.cards.forEach(card =>
            card.addEventListener('click', event => this.onCard(event))
        );
    }

    onMediaCard(event) {
        const { currentTarget } = event;
        const type = currentTarget.getAttribute('data-type');
        const id = currentTarget.getAttribute('data-card-media');
        const gallery = currentTarget.getAttribute('data-card-media-gallery');

        const cards = this.root.querySelectorAll('[data-card-media]');
        if (cards) cards.forEach(item => (item.style.pointerEvents = 'none'));

        console.log(gallery);

        //return;

        if (gallery === '') {
            this.setCardLightbox(currentTarget);
        } else {
            const formData = new FormData();
            formData.append('action', 'media_popup');
            formData.append('type', type);
            formData.append('id', id);

            $.ajax({
                type: 'POST',
                url: ajax.url,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                data: formData,
                success: function (response) {
                    const data = JSON.parse(response);
                    const { html } = data;

                    $('body').append(html);
                    this.setPopup();
                }.bind(this),
                error: function () {}.bind(this),
                complete: function () {
                    const cards = this.root.querySelectorAll('[data-card-media]');
                    if (cards)
                        cards.forEach(item => (item.style.pointerEvents = 'all'));
                }.bind(this),
            });
        }
    }

    setCardLightbox(card) {
        const cards = this.root.querySelectorAll('[data-card-media]');

        this.galleryItemDetails = card.querySelectorAll('.card-media__file-details');
        const galleries = card.querySelectorAll(
            '.card-media__gallery-item'
        );

        if (this.galleryInstance !== null) this.galleryInstance.destroy();
        if (galleries && galleries.length > 0) {
            this.galleryInstance = new simpleLightbox(galleries, {
                closeText: '',
                className: 'card-media-popup'
            });

            this.galleryInstance.on('closed.simplelightbox', function () {
                cards.forEach(item => item.style.pointerEvents = 'all');   
            });

            this.galleryInstance.on('nextDone.simplelightbox', e => {
                const extLinks = document.querySelectorAll('.sl-popup-link');
                if (extLinks) extLinks.forEach(item => item.remove());
    
                this.currentGalleryIndex++;
                if (this.currentGalleryIndex > this.galleryItemDetails.length - 1)
                    this.currentGalleryIndex = 0;
    
                this.appendLightBoxFileData(this.currentGalleryIndex);
            });
    
            this.galleryInstance.on('prevDone.simplelightbox', e => {
                const extLinks = document.querySelectorAll('.sl-popup-link');
                if (extLinks) extLinks.forEach(item => item.remove());
    
                this.currentGalleryIndex--;
                if (this.currentGalleryIndex < 0) this.currentGalleryIndex = this.galleryItemDetails.length;
    
                this.appendLightBoxFileData(this.currentGalleryIndex);
            });
    
            this.galleryInstance.on(
                'shown.simplelightbox',
                function (e) {
                    this.appendLightBoxFileData(0);
                }.bind(this)
            );

            this.galleryInstance.open();
        }
    }

    appendLightBoxFileData(index) {
        const wrapper = document.querySelector('.card-media-popup');
        const popupLinkNode = document.createElement('div');
        popupLinkNode.classList.add('sl-popup-link');

        const details = this.galleryItemDetails[index];
        const node = details.cloneNode(true);
        node.style.display = 'block';
        popupLinkNode.append(node);

        wrapper.append(popupLinkNode);
    }

    setPopup() {
        const popup = document.querySelector('[data-popup]');
        if (popup) new PopupVideo(popup);
    }
}

const sections = document.querySelectorAll('[data-media-section]');
const initPartners = sections => {
    if (!sections) return;

    sections.forEach(el => {
        const isOwnChoice = el.getAttribute('data-is-own-choice');
        new MediaSection(el);
        if (isOwnChoice) {
            mobileCarousel(
                'media-section__mobile-carousel',
                'swiper-pagination-media-section',
                1.4,
                16
            );
        }
    });
};

initPartners(sections);
